var map = {
	"./box.png": "Kn3z",
	"./calculator.png": "FeCq",
	"./check-list.png": "D8Kp",
	"./compass.png": "OU+k",
	"./delivery-man.png": "tQMB",
	"./delivery.png": "qBTC",
	"./phone-call.png": "CQxZ",
	"./pie-chart.png": "tV6u",
	"./promote.png": "XPFB",
	"./search.png": "FPlw",
	"./settings.png": "TJx2",
	"./warehouse.png": "GJiZ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "grk0";